import { Flex, Spinner, rem, Button } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

type LoadMoreClipsProps = {
  loadMoreClips?: () => void | undefined;
  isLoadingMoreClips?: boolean | undefined;
};

export const LoadMoreClips = ({ loadMoreClips, isLoadingMoreClips }: LoadMoreClipsProps) => (
  <Flex justify="center" mb="md">
    {isLoadingMoreClips ? (
      <Spinner h={rem(40)} color="text-primary" /> // height set to 40px to match button so there's no layout shift. Design req to have spinner instead of button loading state
    ) : (
      <Button onClick={loadMoreClips} variant="secondary">
        {translate('Load more')}
      </Button>
    )}
  </Flex>
);
